import { Image as ChakraImage } from "@chakra-ui/react";

/**
 * @deprecated
 * use @cloudspire/shared/components/image instead
 */
export const Image = ChakraImage;
